// The environment the deployment states, read-only, in the top bar; the main area says while it
// loads or failed.
import { useQuery } from '@tanstack/react-query';
import { Result } from 'effect';
import { ENVIRONMENT_LABEL } from '../deployment-gate.tsx';
import { deploymentProfileQueryOptions } from '../edge.ts';

export const EnvironmentBadge = (): JSX.Element | null => {
  const profileQuery = useQuery(deploymentProfileQueryOptions);
  if (profileQuery.status !== 'success' || Result.isFailure(profileQuery.data)) return null;
  return (
    <p className="admin-controls" aria-label="Ambiente da implantação">
      Ambiente{' '}
      <strong className="admin-environment-badge">
        {ENVIRONMENT_LABEL[profileQuery.data.success.environment]}
      </strong>
    </p>
  );
};
